import { render } from "./FirmatechHeader.vue?vue&type=template&id=5c5d650c"
import script from "./FirmatechHeader.vue?vue&type=script&lang=js"
export * from "./FirmatechHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__